  import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address-book-contact-delete"
export default class extends Controller {
  static targets = ['clonedField']

  addDeletedContact([destroy_field, id_field], id) {
    this._appenClonedField(destroy_field, id)
    this._appenClonedField(id_field, id)
  }

  removeDeletedContact(id) {
    if (!this.hasClonedTarget || !id) return

    let form = this.element.closest("form")
    this.clonedFieldTargets.filter(ele => ele.dataset.id == id).forEach(ele => this.element.removeChild(ele))
  }

  _appenClonedField(field, id) {
    if(!field || !id) return
    
    let cloned_field = field.cloneNode(true)
    cloned_field.setAttribute("data-id", id)
    cloned_field.setAttribute("data-address-book-contact-delete-target", "clonedField")
    this.element.appendChild(cloned_field)
  }
}
